import axios from "axios";
import { AxiosInstancePrivate } from "./AxiosInstance";
import { Endpoints } from "./Endpoints";

const axiosInstance = AxiosInstancePrivate();

export const fetchRegistrationList = async (payload) => {
    const response = await axiosInstance.post(Endpoints.getRegistrations, payload);
    return response?.data;
};

export const fetchUserInformation = async (payload) => {
    const response = await axiosInstance.post(Endpoints.getUserInformation, payload);
    return response?.data;
};

export const fetchRegistrationDetail = async (registration_id) => {
    const response = await axiosInstance.post(Endpoints.getRegistrationDetails, { registration_id: registration_id });
    return response?.data;
};

export const fetchEntitlementList = async (payload) => {
    const response = await axiosInstance.post(Endpoints.getEntitlements, payload);
    return response?.data;
};


export const skuSearch = async (payload) => {
    const response = await axiosInstance.post(Endpoints.getProductsSku, { sku_keyword: payload });
    return response?.data;
};

export const retailerSearch = async (payload) => {
    const response = await axiosInstance.post(Endpoints.getRetailers, { retailer_name: payload });
    return response?.data;
};

export const retailerSearchByType = async (payload) => {
    const response = await axiosInstance.post(Endpoints.getRetailersByType, { retailer_type: payload });
    return response?.data;
};

export const retailerSearchByCountry = async (payload) => {
    const response = await axiosInstance.post(Endpoints.getRetailersByCountry, { country_code: payload });
    return response?.data;
};

export const editRegistrationDetails = async (payload) => {
    const response = await axiosInstance.post(Endpoints.editRegistrationDetails, payload);
    return response?.data;
};

export const deleteProduct = async (payload) => {
    const response = await axiosInstance.post(Endpoints.deleteProduct, payload);
    return response?.data;
};

export const deleteProofOfPurchase = async (payload) => {
    const response = await axiosInstance.post(Endpoints.deleteProofOfPurchase, payload);
    return response?.data;
};

export const deleteUser = async (payload) => {
    const response = await axiosInstance.post(Endpoints.deleteUser, payload);
    return response?.data;
};

export const uploadProofOfPurchase = async (payload, file) => {
    const response = await axiosInstance.post(Endpoints.uploadProofOfPurchase, payload);
    const S3Url = response?.data?.split('&x-amz-security-token')[0];
    const data = await axios({ method: "PUT", url: S3Url, data: file, headers: { 'Content-Type': file.type } })
    return data
};


export const getActiveCampaignDetails = async () => {
    const response = await axiosInstance.post(Endpoints.getActiveCampaignDetails);
    return response?.data;
};

export const updateActiveCampaignDetails = async (payload) => {
    const response = await axiosInstance.post(Endpoints.updateActiveCampaignDetails, payload);
    return response?.data;
};

export const getReports = async (payload) => {
    const response = await axiosInstance.post(Endpoints.getReports, payload);
    return response?.data;
};

export const getBulkReports = async (payload) => {
    const response = await axiosInstance.post(Endpoints.getBulkReports, payload);
    return response?.data;
};

export const generateBulkReports = async (payload) => {
    const response = await axiosInstance.post(Endpoints.generateBulkReports, payload);
    return response?.data;
};

export const getAccountDetails = async (payload) => {
    const response = await axiosInstance.post(Endpoints.getAccountDetails, payload);
    return response?.data;
};

export const accountTransfer = async (payload) => {
    const response = await axiosInstance.post(Endpoints.accountTransfer, payload);
    return response?.data;
};

export const makeExternalCalls = async (token, id, type) => {
    const response = await axiosInstance.post(Endpoints.externalCalls, { token, id , type });
    return response?.data;
};

export const getProtectionPlans = async (pagination, filter) => {
    const response = await axiosInstance.post(Endpoints.getProtectionPlans, { ...pagination, filter });
    return response?.data;
};

export const getProductsByCampaign = async (payload) => {
    const response = await axiosInstance.post(Endpoints.getProductsByCampaign, payload);
    return response?.data;
};

export const uploadProtectionPlans = async (payload) => {
    const response = await axiosInstance.post(
        Endpoints.uploadProtectionPlans,
        payload
    );
    return response?.data;
};

export const triggerS3FileReadCsvProtectionPlan = async (payload) => {
    const response = await axiosInstance.post(
        Endpoints.triggerS3FileReadCsvProtectionPlan,
        payload
    );
    return response?.data;
};

export const getRetailersAndCountryCode = async () => {
//   console.log("inside getRetailersAndCountryCode");
  const response = await axiosInstance.post(
    Endpoints.getRetailersAndCountryCode,
  );
  return response?.data;
};

export const addRetailer = async (payload) => {
//   console.log("inside addRetailer");
  const response = await axiosInstance.post(Endpoints.addRetailer, payload);
  if (response?.data) {
    return response?.data?.[0];
  } else {
    throw new Error("Failed to add retailer! ", response?.message);
  }
};
export const editRetailer = async (payload) => {
//   console.log("inside editRetailer");
  const response = await axiosInstance.post(Endpoints.editRetailer, payload);
  console.log(response)
  if (response?.data) {
    return response?.data?.[0];
  } else {
    throw new Error("Failed to update retailer info! ", response?.message);
  }
};

export const deletRetailer = async (payload) => {
//   console.log("inside deletRetailer");
  const response = await axiosInstance.post(Endpoints.deleteRetailer, payload);
  if (response?.data) {
    return response?.data?.[0];
  } else {
    throw new Error("Failed to delete retailer! ", response?.message);
  }
};

export const exportRetailer = async () => {
//   console.log("inside exportRetailer");
  const response = await axiosInstance.post(Endpoints.exportRetailer);
  if (response?.data) {
    return response?.data;
  } else {
    throw new Error("Failed to export retailers! ", response?.message);
  }
};
